import { TitleCasePipe } from '@angular/common';
import { Component, OnInit, OnDestroy, Output, EventEmitter, AfterViewInit, ViewChild, HostListener, ElementRef } from '@angular/core';
import { IBlankslate, IButtonOptions, ICheckbox, IDropdown, ToastService, IToast, ITableConfig, IDropdownCustom, ITag } from 'codex-lib';
import { TranslateService } from '@ngx-translate/core';
import { Signatory } from '../model/signatory';
import { TableSignUser } from '../model/tableSignUser';
import { Subscription } from 'rxjs';
import { NgbModalConfig, NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NewEnvelopeService } from 'src/app/envelope/new-envelope/new-envelope.service';
import { ObjectUtil } from '../ObjectUtil';
import { NewEnvelopeSteps } from 'src/app/enum/new-envelope-steps';
import { CPFCNPJUtil } from 'src/app/util/CPF-CNPJ-util';
import { SurvicateService } from 'src/app/services/survicate.service';
import { AuthService } from 'src/app/services/auth.service';
import { ModalIntentType } from 'src/app/enum/modal-intent-type.enum';
import { ParticipantTypeEnum } from 'src/app/enum/participant.enum';
import { MainEnvelopeComponent } from 'src/app/main-envelope/main-envelope.component';
import { TrackerData } from 'src/app/modules/google-analytics/model/tracker-data.model';
import { AnalyticEventClient } from 'src/app/enum/analytic-event-client.enum';
import { AnalyticsService } from 'src/app/modules/google-analytics/service/analytics.service';
import { BrowserUtil } from 'src/app/util/browser-util';
import { StringUtil } from 'src/app/util/string-util';
import { EnvelopeDataTableService } from '../services/envelope-data-table.service';
import { SignatoryTypeRoleService } from 'src/app/modules/contacts/services/signature-type-role.service';
import { SignatoryTypeRole } from 'src/app/modules/contacts/model/signatory-type-role';

@Component({
  selector: 'envelope-signatory',
  templateUrl: './signatory.component.html',
  styleUrls: ['./signatory.component.scss']
})
export class SignatoryComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('signatoryTypeRoleDropdown', { static: false }) signatoryTypeRoleDropdown: any;
  @ViewChild('signatoryTableContainer', { static: false }) signatoryTableContainer: ElementRef<HTMLElement>;
  private signatoryTypeRolePageSize = 0;
  private signatoryTypeRolePageLimit = 25;
  private signatoryTypeRoleSearch = '';
  private pendingSignatoryTypeRoleSearch: string | null = null;
  private signatoryTypeRoleRequestId = 0;
  private hasMoreSignatoryTypeRoleItems = true;
  private signatoryTypeRoleLoadedItems = [];
  isLoadingSignatoryTypeRoles = false;
  signatoryTableDropdownWidth = 280;

  @Output() closeDialogClick = new EventEmitter();
  @Output() submitDialogClick = new EventEmitter();

  isMobile: boolean = BrowserUtil.isMobile();
  tableUser: TableSignUser;
  blankSlate: IBlankslate;
  blankSlateSearch: IBlankslate;
  addIcon: IButtonOptions;
  checkboxOptions: ICheckbox;
  rememberOptions: IDropdown;
  signatoryTypeRoleItems: IDropdownCustom;
  signatureTypeDropdownOptions: IDropdown;
  signatoryTypeRoleDropdownOptions: IDropdown;
  signUsers: Subscription;
  stepModelSubscription: Subscription;
  checkboxAllElements: Boolean;
  searchText = '';
  activeModal: NgbActiveModal;
  toastPosition: string;
  settings: any;
  hiddenPhoneColumn: boolean;
  modalIntentType = ModalIntentType;
  participantType = ParticipantTypeEnum;
  dataTableOptions: ITableConfig;
  inactiveTag: ITag;

  signatureTypeItems;
  subscriberTypeItems;

  model: {
    elements: Array<Signatory>;
    reminderFrequency: any;
    accessAuthentication: boolean;
    isOrdered: boolean;
    authorizer: boolean;
    observer: boolean;
    responsible: boolean;
  };

  constructor(
    private authService: AuthService,
    private titleCasePipe: TitleCasePipe,
    private translate: TranslateService, modalConfig: NgbModalConfig, private modalService: NgbModal,
    private newEnvelopeService: NewEnvelopeService, private toastService: ToastService, private survicateService: SurvicateService,
    private mainEnvelopeComponent: MainEnvelopeComponent,
    private googleAnalitycsService: AnalyticsService,
    private envelopeDataTableService: EnvelopeDataTableService,
    private signatoryTypeRoleService: SignatoryTypeRoleService) {
    this.model = {
      elements: new Array<Signatory>(),
      reminderFrequency: {},
      accessAuthentication: false,
      isOrdered: false,
      authorizer: false,
      observer: false,
      responsible: false
    };
    this.tableUser = new TableSignUser(translate);
    this.checkboxAllElements = false;
    this.signUsers = this.tableUser.signUsers.subscribe(x => {
      this.model.elements = x;
      this.model.elements.forEach(e => {
        e.ssnWithMask = e.ssn ? CPFCNPJUtil.obfuscateCpfCnpj(CPFCNPJUtil.formatSsn(e.ssn)) : '';
      });
      this.sortElements();
      this.model = this.newEnvelopeService.setModelData(this.model);
      this.validateAllCheckboxCheckedTable();
      this.refreshDataTableOptions();
      this.scheduleSignatoryTableDropdownWidthUpdate();
    });

    this.stepModelSubscription = this.newEnvelopeService.stepModelSubject.subscribe(modelData => {
      this.model = modelData;
      this.sortElements();
      this.refreshDataTableOptions();
      this.scheduleSignatoryTableDropdownWidthUpdate();
    });

    if (!this.authService.signUserModel) {
      return;
    }

    this.hiddenPhoneColumn = !this.mainEnvelopeComponent.isSendWhatsapp;

    modalConfig.backdrop = 'static';
    modalConfig.keyboard = false;
  }

  sortElements() {
    if (this.model.isOrdered) {
      this.model.elements.sort((a, b) => a.order - b.order);
    } else {
      this.model.elements.sortBy('name');
    }
  }

  public trackById(index: number, item: Signatory) {
    return item?.id ?? index;
  }

  @HostListener('window:resize')
  onWindowResize(): void {
    this.updateSignatoryTableDropdownWidth();
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.loadSignatoryTypeRoleItems();
      this.loadSignatoryTypeRoleDropdownItems();
      this.signatureTypeItems = this.tableUser.signatureType.List();
      this.signatureTypeDropdownOptions = {
        ...this.signatureTypeDropdownOptions,
        items: this.signatureTypeItems
      };
      this.updateSignatoryTableDropdownWidth();
    }, 250);
  }

  ngOnDestroy(): void {
    this.signUsers.unsubscribe();
    this.stepModelSubscription.unsubscribe();
  }

  ngOnInit() {
    this.updateSignatoryTableDropdownWidth();

    this.rememberOptions = {
      displayText: 'value',
      placeholder: this.translate.instant('envelope.signatory.reminderFrequency.placeholder'),
      items: [
        { id: 1, value: this.translate.instant('envelope.signatory.reminderFrequency.doNotSend') },
        { id: 2, value: this.translate.instant('envelope.signatory.reminderFrequency.EveryDay') },
        { id: 3, value: this.translate.instant('envelope.signatory.reminderFrequency.EveryCountDay', { dayCount: 2 }) },
        { id: 4, value: this.translate.instant('envelope.signatory.reminderFrequency.EveryCountDay', { dayCount: 4 }) },
        { id: 5, value: this.translate.instant('envelope.signatory.reminderFrequency.EveryCountDay', { dayCount: 7 }) }
      ],
      showSearch: false
    };

    this.signatureTypeDropdownOptions = {
      displayText: 'value',
      placeholder: this.translate.instant('selectAnItem'),
      items: [],
      showSearch: false,
      containerBody: true
    };

    this.signatoryTypeRoleDropdownOptions = {
      displayText: 'name',
      placeholder: this.translate.instant('selectAnItem'),
      items: [],
      showSearch: true,
      containerBody: true
    };

    this.inactiveTag = {
      description: 'inactive',
      tooltip: 'envelope.signatory.tooltip.signatoryTypeRoleInactive',
      tooltipPlacement: 'top'
    };

    this.signatoryTypeRoleItems = {
      displayText: 'description',
      listMaxHeight: 150,
      placement: 'bottom-right',
      circleButton: {
          typeIcon: 'far',
          Icon: 'file-edit'
      },
	    showSearch: true,
      overrideInternalSearch: true,
      useInfiniteScroll: true,
      infiniteScrollOptions: {
        infiniteScrollDistance: 1,
        infiniteScrollThrottle: 50
      },
      title: "subscriberTypeText",
      groups: [[]]
    }

    Object.assign(this.model, this.newEnvelopeService.getModelData(this.newEnvelopeService.getCurrentStep()));
    if (this.survicateService.isSignFree()) {
      if (!(this.model.reminderFrequency) || ObjectUtil.isEmpty(this.model.reminderFrequency)) {
        this.model.reminderFrequency = this.rememberOptions.items[2];
      }
    } else {
      if (!(this.model.reminderFrequency) || ObjectUtil.isEmpty(this.model.reminderFrequency)) {
        this.model.reminderFrequency = this.rememberOptions.items[0];
      }
    }

    this.tableUser.addList(this.model.elements);

    this.blankSlate = {
      icon: {
        prefix: 'fad',
        iconName: 'user-plus'
      },
      buttonText: 'add'
    };

    this.blankSlateSearch = {
      icon: {
        prefix: 'fad',
        iconName: 'search-minus'
      },
      buttonText: 'cleanSearch'
    };

    this.addIcon = {
      isItem: false,
      icon: {
        prefix: 'fad',
        iconName: 'plus'
      },
      text: '',
      isMinimize: false
    };

    this.settings = this.newEnvelopeService.getModelData(NewEnvelopeSteps.Settings).value;
    this.refreshDataTableOptions();
    this.scheduleSignatoryTableDropdownWidthUpdate();
  }

  private refreshDataTableOptions(): void {
    const selectedCount = this.model.elements.filter((element) => !!element[TableSignUser.propCheck]).length;
    const allSelected = this.model.elements.length > 0 && selectedCount === this.model.elements.length;
    const partiallySelected = selectedCount > 0 && !allSelected;
    
    const headers = this.envelopeDataTableService.buildHeader(
      [
        { text: this.titleCasePipe.transform(this.translate.instant('order')), show: this.model.isOrdered, width: 50 },
        { text: this.titleCasePipe.transform(this.translate.instant('name')), show: true },
        { text: this.titleCasePipe.transform(this.translate.instant('mail')), show: true },
        { text: this.translate.instant('ssn').toUpperCase(), show: this.settings?.language?.id === 1 },
        { text: this.translate.instant('phone'), show: !this.hiddenPhoneColumn },
        { text: this.translate.instant('envelope.signatory.signatureTypeText'), show: true },
        { text: this.translate.instant('envelope.signatory.subscriberTypeText'), show: true },
      ]
    );
    const body = this.envelopeDataTableService.buildBody(
      this.model.elements.map((signatory) => ({
        row: 
        [
          { display: String(signatory.order || '-') },
          { display: signatory.name },
          { display: StringUtil.obfuscateMail(signatory.mail) || '-' },
          { display: CPFCNPJUtil.obfuscateCpfCnpj(signatory.ssnWithMask) || '-' },
          { display: StringUtil.obfuscateTelephone(signatory.phoneNumber) || '-' },
          { display: signatory.signatureType?.value || '-' },
          { display: signatory.signatoryTypeRole?.name || signatory.subscriberTypeValue || '-' },
        ],
        metaData: { isSelected: !!signatory[TableSignUser.propCheck] },
      }))
    );

    this.checkboxAllElements = allSelected;

    this.dataTableOptions = this.envelopeDataTableService.refreshDataTableOptions(headers, body, {
      isSelectable: true,
      isTableFull: true,
      allSelected,
      partiallySelected
    });
  }

  onDataTableChange(event: { allSelected?: boolean; partiallySelected?: boolean }): void {
    if (!this.dataTableOptions?.body?.length) {
      return;
    }

    this.model.elements.forEach((element, index) => {
      const isSelected = !!this.dataTableOptions.body[index]?.metaData?.isSelected;
      element[TableSignUser.propCheck] = isSelected;
    });

    this.checkboxAllElements = !!event?.allSelected;
    this.dataTableOptions = {
      ...this.dataTableOptions,
      allSelected: !!event?.allSelected,
      partiallySelected: !!event?.partiallySelected,
    };

    this.newEnvelopeService.setModelData(this.model);
  }

  getSelectedSignatureType(signatory: Signatory) {
    const selectedId = signatory?.signatureType?.id;
    return this.signatureTypeItems?.find(item => item.id === selectedId) || signatory?.signatureType || null;
  }

  getSelectedSignatoryTypeRole(signatory: Signatory): SignatoryTypeRole {
    if (signatory?.signatoryTypeRole) {
      return signatory.signatoryTypeRole;
    }

    return this.signatoryTypeRoleDropdownOptions?.items
      ?.find((item: SignatoryTypeRole) => item.id === signatory?.signatoryTypeRoleId) || null;
  }

  confirmModalClose() {
    this.activeModal.dismiss();
  }

  confirmModalYesClick() {
    this.removeSignatory();
    this.activeModal.dismiss();
  }

  showConfirmationDelete(confirmModalContent) {
    this.activeModal = this.modalService.open(confirmModalContent);
  }

  toogleCheckout(el) {
    el.checked = !el.checked;
  }

  onCheckboxOptions(el): ICheckbox {
    el[TableSignUser.propCheck] = (el) ? (el[TableSignUser.propCheck]) ? el[TableSignUser.propCheck] : false : false;
    const box = {
      span: '',
      checked: el[TableSignUser.propCheck]
    };
    return box;
  }

  validateAllCheckboxCheckedTable() {
    let allCheked = true;
    allCheked = this.model.elements.every(element => element[TableSignUser.propCheck]);
    if (allCheked || this.checkboxAllElements) {
      this.checkboxAllElements = allCheked;
    }
  }

  onCheckbox(ev, el) {
    const obj = {};
    obj[TableSignUser.propCheck] = ev;
    this.tableUser.updateElement(el, obj);
    this.searchText = '';
  }

  onCheckboxAll(ev) {
    this.checkboxAllElements = ev;
    const obj = {};
    obj[TableSignUser.propCheck] = ev;
    this.tableUser.updateElements(obj);
  }

  showAddSignatoryModal(modalContent) {
    this.activeModal = this.modalService.open(modalContent, { size: 'xl', scrollable: true });
  }

  removeSignatory() {
    for (let index = 0; index < this.model.elements.length;) {

      const el = this.model.elements[index];

      if (el[TableSignUser.propCheck]) {
        this.tableUser.removeEl(el);

        let indexUpdate = index;

        if (this.model.isOrdered) {
          const notReorder = this.model.elements.some(x => x.order === el.order);
          while (indexUpdate < this.model.elements.length && !notReorder) {
            this.model.elements[indexUpdate].order = this.model.elements[indexUpdate].order != 1 ?
              this.model.elements[indexUpdate].order - 1 :
              this.model.elements[indexUpdate].order;
            indexUpdate++;
          }
        }

      } else {
        index++;
      }
    }

    this.searchText = '';
    this.checkboxAllElements = false;
  }

  showOrdersSignatoryModal(modalContent) {
    this.activeModal = this.modalService.open(modalContent, { size: 'm' });
  }

  onSearch(ev) {
    this.searchText = ev;
    this.tableUser.getList(this.searchText);
  }

  emitSignType(item) {
    this.model.elements
      .filter(el => el[TableSignUser.propCheck])
      .forEach(el => this.updateSignatorySignatureType(el, item));

    if (this.shouldRestoreDocumentForSignatureType(item)) {
      this.restoreDocument();
    }

    this.persistSignatoryChanges();
  }

  onSubscriberTypeChange(item) {
    const selectedItem = this.normalizeSignatoryTypeRole(item);

    this.model.elements.forEach(el => {
      if (el[TableSignUser.propCheck]) {
        this.updateSignatoryTypeRole(el, selectedItem);
      }
    });
    this.persistSignatoryChanges();
  }

  onSignatureTypeChange(signatory: Signatory, item): void {
    if (!item || signatory?.signatureType?.id === item.id) {
      return;
    }

    this.updateSignatorySignatureType(signatory, item);

    if (this.shouldRestoreDocumentForSignatureType(item)) {
      this.restoreDocument();
    }

    this.persistSignatoryChanges();
  }

  onSignatoryTypeRoleChange(signatory: Signatory, item: SignatoryTypeRole): void {
    if (!item || signatory?.signatoryTypeRoleId === item.id) {
      return;
    }

    this.updateSignatoryTypeRole(signatory, item);
    this.persistSignatoryChanges();
  }

  onSignatoryTypeRoleSearch(value: string): void {
    const normalizedValue = value || '';
    if (normalizedValue === this.signatoryTypeRoleSearch && this.pendingSignatoryTypeRoleSearch === null) {
      return;
    }

    if (this.isLoadingSignatoryTypeRoles) {
      this.pendingSignatoryTypeRoleSearch = normalizedValue;
      return;
    }

    this.resetSignatoryTypeRolePagination(normalizedValue);
    this.loadSignatoryTypeRoleItems();
  }

  onSignatoryTypeRoleInfiniteScroll(event: { isScrolled: boolean }): void {
    if (!event?.isScrolled || this.isLoadingSignatoryTypeRoles || !this.hasMoreSignatoryTypeRoleItems) {
      return;
    }

    this.getNextSignatoryTypeRolePage();
  }

  onSignatoryTypeRoleDropdownClick(): void {
      const activeButtons = document.querySelector('.main-dropdown.newDropdown.dropdown-menu.show .dropdown-item-btn.active');
      activeButtons?.classList.remove('active');
  }

  private getSignatoryTypeRoleSkipFilter(): number {
    return this.signatoryTypeRolePageSize * this.signatoryTypeRolePageLimit;
  }

  private getSignatoryTypeRoleTakeFilter(): number {
    return this.signatoryTypeRolePageLimit;
  }

  private getNextSignatoryTypeRolePage(): void {
    this.signatoryTypeRolePageSize++;
    this.loadSignatoryTypeRoleItems();
  }

  private loadSignatoryTypeRoleItems(): void {
    if (this.isLoadingSignatoryTypeRoles || !this.hasMoreSignatoryTypeRoleItems) {
      return;
    }

    this.isLoadingSignatoryTypeRoles = true;
    const currentRequestId = ++this.signatoryTypeRoleRequestId;
    this.signatoryTypeRoleService
      .getWithFilter({
        active: true,
        inactive: false,
        skip: this.getSignatoryTypeRoleSkipFilter(),
        take: this.getSignatoryTypeRoleTakeFilter(),
        name: this.signatoryTypeRoleSearch || undefined
      }, true)
      .subscribe({
        next: (signatoryTypeRoles) => {
          if (currentRequestId !== this.signatoryTypeRoleRequestId) {
            return;
          }

          const fetchedItems = signatoryTypeRoles || [];
          this.hasMoreSignatoryTypeRoleItems = fetchedItems.length === this.signatoryTypeRolePageLimit;
          this.signatoryTypeRoleLoadedItems = this.signatoryTypeRoleLoadedItems.concat(fetchedItems);

          const groupItems = this.signatoryTypeRoleLoadedItems.map((signatoryTypeRole) => ({
            properties: {
              id: signatoryTypeRole.id,
              description: signatoryTypeRole.name,
              isActive: signatoryTypeRole.isActive,
              isDefault: signatoryTypeRole.isDefault
            }
          }));

          this.signatoryTypeRoleItems = {
            ...this.signatoryTypeRoleItems,
            useInfiniteScroll: this.hasMoreSignatoryTypeRoleItems,
            groups: [groupItems]
          };
          this.signatoryTypeRoleDropdown?.forceOptionsUpdate?.(this.signatoryTypeRoleItems);

          this.subscriberTypeItems = this.signatoryTypeRoleLoadedItems.map(signatoryTypeRole => ({
            id: signatoryTypeRole.id,
            value: signatoryTypeRole.name
          }));

          this.isLoadingSignatoryTypeRoles = false;
          this.consumePendingSignatoryTypeRoleSearch();
        },
        error: () => {
          if (currentRequestId !== this.signatoryTypeRoleRequestId) {
            return;
          }

          this.hasMoreSignatoryTypeRoleItems = false;
          this.isLoadingSignatoryTypeRoles = false;
          this.signatoryTypeRoleItems = {
            ...this.signatoryTypeRoleItems,
            useInfiniteScroll: false
          };
          this.signatoryTypeRoleDropdown?.forceOptionsUpdate?.(this.signatoryTypeRoleItems);
          this.consumePendingSignatoryTypeRoleSearch();
        }
      });
  }

  private loadSignatoryTypeRoleDropdownItems(): void {
    this.signatoryTypeRoleService
      .getWithFilter({
        active: true,
        inactive: false,
        skip: 0,
        take: 500
      }, false)
      .subscribe({
        next: (signatoryTypeRoles) => {
          this.signatoryTypeRoleDropdownOptions = {
            ...this.signatoryTypeRoleDropdownOptions,
            items: signatoryTypeRoles || []
          };
        },
        error: () => {
          this.signatoryTypeRoleDropdownOptions = {
            ...this.signatoryTypeRoleDropdownOptions,
            items: []
          };
        }
      });
  }

  private normalizeSignatoryTypeRole(item: any): SignatoryTypeRole {
    if (!item) {
      return null;
    }

    if (!item.properties) {
      return item;
    }

    return {
      id: item.properties.id,
      name: item.properties.description,
      isActive: item.properties.isActive,
      isDefault: item.properties.isDefault,
      checked: false
    };
  }

  private updateSignatorySignatureType(signatory: Signatory, item): void {
    if (!signatory || !item) {
      return;
    }

    signatory.signatureType = item;
  }

  private updateSignatoryTypeRole(signatory: Signatory, item: SignatoryTypeRole): void {
    if (!signatory || !item) {
      return;
    }

    signatory.signatoryTypeRoleId = item.id;
    signatory.signatoryTypeRole = {
      ...(signatory.signatoryTypeRole || {}),
      id: item.id,
      name: item.name,
      isActive: item.isActive,
      checked: signatory.signatoryTypeRole?.checked ?? false,
      isDefault: item.isDefault
    };
  }

  private shouldRestoreDocumentForSignatureType(item): boolean {
    return item?.id == 0 || item?.id == 1;
  }

  private persistSignatoryChanges(): void {
    this.model = this.newEnvelopeService.setModelData(this.model);
    this.refreshDataTableOptions();
    this.scheduleSignatoryTableDropdownWidthUpdate();
  }

  private scheduleSignatoryTableDropdownWidthUpdate(): void {
    setTimeout(() => this.updateSignatoryTableDropdownWidth());
  }

  private updateSignatoryTableDropdownWidth(): void {
    this.signatoryTableDropdownWidth = this.resolveSignatoryTableDropdownWidth();
  }

  private resolveSignatoryTableDropdownWidth(): number {
    const tableContainerWidth = this.signatoryTableContainer?.nativeElement?.clientWidth;

    if (!tableContainerWidth) {
      return 280;
    }

    if (tableContainerWidth <= 360) {
      return 130;
    }

    if (tableContainerWidth <= 420) {
      return 150;
    }

    if (tableContainerWidth <= 500) {
      return 170;
    }

    if (tableContainerWidth <= 600) {
      return 200;
    }

    if (tableContainerWidth <= 720) {
      return 220;
    }

    if (tableContainerWidth <= 860) {
      return 240;
    }

    return 280;
  }

  private resetSignatoryTypeRolePagination(searchValue: string): void {
    this.signatoryTypeRoleSearch = searchValue;
    this.signatoryTypeRolePageSize = 0;
    this.hasMoreSignatoryTypeRoleItems = true;
    this.signatoryTypeRoleLoadedItems = [];
  }

  private consumePendingSignatoryTypeRoleSearch(): void {
    if (this.pendingSignatoryTypeRoleSearch === null) {
      return;
    }

    const pendingSearch = this.pendingSignatoryTypeRoleSearch;
    this.pendingSignatoryTypeRoleSearch = null;
    this.resetSignatoryTypeRolePagination(pendingSearch);
    this.loadSignatoryTypeRoleItems();
  }

  onBlankSlateSearchClick() {
    this.onSearch('');
  }

  onSelectFrequency(ev) {
    this.model.reminderFrequency = ev;
    this.newEnvelopeService.setModelData(this.model);
  }

  closeModalClick() {
    this.activeModal.dismiss();
  }

  anyCheckedElement(): boolean {
    return this.model.elements.anyChecked(TableSignUser.propCheck);
  }

  submitAddModalClick(event: { data: any, isEdited: boolean }) {
    if (event.isEdited) {
      this.tableUser.updateByElementId(event.data);
    } else {
      if (!Array.isArray(event.data))
        return;

      event.data.map(x => x[TableSignUser.propCheck] = false);
      const countNewUsers = this.tableUser.mergeList(event.data);
      this.activeModal.close();

      if (countNewUsers > 0) {
        const toastUsersAdded: IToast = {
          text: this.translate.instant('envelope.signatory.toast.addedNotification', { count: countNewUsers }),
          autoHide: true
        };
        this.toastService.createNewToast(toastUsersAdded);
      }
    }
    this.refreshDataTableOptions();
  }

  submitModalClick() {
    const toastUsersOrdered: IToast = {
      text: this.translate.instant('envelope.signatory.toast.orderedNotification'),
      autoHide: true
    };
    this.toastService.createNewToast(toastUsersOrdered);
    this.activeModal.dismiss();
  }

  onToggleEnableAuthorizer(event) {
    this.googleAnalitycsService.sendEvent(
      new TrackerData(
        AnalyticEventClient.TK_PT_SIGNER_NEW_ENVELOPE,
        'Signer_NovEnv_Aprovadores',
        event ? 'Ativo' : 'Inativo'
      )
    );
    this.model.authorizer = event;
    if (!this.model.authorizer) {
      this.model = this.newEnvelopeService.setModelData({ ...this.model, envelopeAuthorizers: [] });
    }
  }

  onToggleEnableObserver(event) {
    this.googleAnalitycsService.sendEvent(
      new TrackerData(
        AnalyticEventClient.TK_PT_SIGNER_NEW_ENVELOPE,
        'Signer_NovEnv_Observadores',
        event ? 'Ativo' : 'Inativo'
      )
    );
    this.model.observer = event;
    if (!this.model.observer) {
      this.model = this.newEnvelopeService.setModelData({ ...this.model, envelopeObservers: [] });
    }
  }

  onToggleEnableResponsible(event) {
    this.googleAnalitycsService.sendEvent(
      new TrackerData(
        AnalyticEventClient.TK_PT_SIGNER_NEW_ENVELOPE,
        'Signer_NovEnv_ResponsavelForm',
        event ? 'Ativo' : 'Inativo'
      )
    );

    this.model.responsible = event;
    if (!this.model.responsible) {
      this.newEnvelopeService.includeComponent = false;
      this.newEnvelopeService.excludeAllCustomFields();
      this.model = this.newEnvelopeService.setModelData({ ...this.model, envelopeResponsible: [] });
      return;
    }

    this.newEnvelopeService.includeComponent = true;
  }

  onToggleAccessAuthentication(event) {
    this.googleAnalitycsService.sendEvent(
      new TrackerData(
        AnalyticEventClient.TK_PT_SIGNER_NEW_ENVELOPE,
        'Signer_NovEnv_AutenticaçãoSignatarios',
        event ? 'Ativo' : 'Inativo'
      )
    );
    this.model.accessAuthentication = event;
  }

  restoreDocument() {
    this.newEnvelopeService.excludeAllSignature();
    this.newEnvelopeService.includeSignature = false;
    this.newEnvelopeService.excludeAllRubric();
    this.newEnvelopeService.includeRubrics = false;
  }
}
